export default "__VITE_ASSET__dd8fd217__"